import React from "react";
import style from "styled-components";
import PropTypes from "prop-types";

export const Image = style.img`
   width:${(props) => `${props.width}px`};
    height:${(props) => `${props.height}px`};
    max-height:${(props) => `${props.height}px`};
    align-self:center;
`;

export default function ComponentImage({ width, height, img }) {
    return <Image src={img} width={width} height={height} />;
}


ComponentImage.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    img: PropTypes.string
};
